import { useState } from 'react';
import { api } from '../lib/api.js';
import { Field } from './Field.jsx';
import { inputStyle } from '../lib/ui.js';
import { ProfileSection } from './ProfileSection.jsx';
import { ReadField } from './ReadField.jsx';

// The weekly hours a person would like to work (CJ 2026-10-07). Optional at
// both ends — "some do have a preference" — and editable by the person on
// their own profile or by a manager on their behalf (the server applies the
// same who-may-edit rules as the rest of the profile).

export function describeHours(min, max) {
  if (min == null && max == null) return 'No preference given';
  if (min != null && max != null) return min === max ? `${min} hours a week` : `${min}–${max} hours a week`;
  return min != null ? `At least ${min} hours a week` : `Up to ${max} hours a week`;
}

export function DesiredHoursCard({ profile, canEdit, isSelf, headers, onSaved }) {
  const [form, setForm] = useState(null);   // null = not editing
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function save() {
    setSaving(true); setError('');
    try {
      await api('PUT', `/api/profile/${profile.id}`, { desired_hours_min: form.min, desired_hours_max: form.max }, headers);
      setForm(null); onSaved();
    } catch (e) {
      let m = e?.message || 'Save failed';
      try { m = JSON.parse(m).error || m; } catch { /* not JSON */ }
      setError(m);
    } finally { setSaving(false); }
  }
  const input = (key, label, placeholder) => (
    <Field label={label}>
      <input type="number" inputMode="numeric" min="0" max="60" step="1" value={form[key]} placeholder={placeholder}
        onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))} style={inputStyle} />
    </Field>
  );
  return (
    <ProfileSection title="Hours wanted" canEdit={canEdit} editing={form !== null}
      onEdit={() => { setError(''); setForm({ min: profile.desired_hours_min ?? '', max: profile.desired_hours_max ?? '' }); }}
      onCancel={() => setForm(null)} onSave={save} saving={saving}>
      {form !== null ? (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 8 }}>
            {input('min', 'Fewest hours a week', 'no minimum')}
            {input('max', 'Most hours a week', 'no maximum')}
          </div>
          <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>
            {isSelf ? 'Optional. Tell us the range you would like and we will try to schedule within it; leave either box blank if you have no preference.'
                    : 'Optional. Leave either box blank if they have no preference.'}
          </div>
          {error && <div role="alert" style={{ fontSize: 12, color: '#b00020', marginTop: 6 }}>{error}</div>}
        </>
      ) : (
        <ReadField label="Weekly hours" value={describeHours(profile.desired_hours_min, profile.desired_hours_max)} />
      )}
    </ProfileSection>
  );
}
